import globals from "./globals";
import $ from "cash-dom";

const component = (function () {
    $(window).on("load", function () {
        if ($("#dynamic-styles").length) {
            if (globals.debug) console.log("component-dynamic-variables initialized");
            function setDynamicVariables() {
                var stylesheet = $("#dynamic-styles")[0];
                var ruleSet = ":root { \n";

                ruleSet += `--100vw: ${window.innerWidth}px; \n`;
                ruleSet += `--100vh: ${window.innerHeight}px; \n`;
                ruleSet += `--vw: ${window.innerWidth / 100}px; \n`;
                ruleSet += `--vh: ${window.innerHeight / 100}px; \n`;
                ruleSet += `--col: ${window.innerWidth / 12}px; \n`;

                ruleSet += "}";
                stylesheet.innerHTML = ruleSet;
            }

            setDynamicVariables();

            $(window).on("resize", setDynamicVariables);
        }
    });
})();

export default component;
